import { render, staticRenderFns } from "./Roadmap.vue?vue&type=template&id=61e3e5ec&scoped=true"
import script from "./Roadmap.vue?vue&type=script&lang=js"
export * from "./Roadmap.vue?vue&type=script&lang=js"
import style0 from "./Roadmap.vue?vue&type=style&index=0&id=61e3e5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3e5ec",
  null
  
)

export default component.exports